import React from 'react'
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion'
import { Link, useLocation } from 'react-router-dom';
import './MasterProjectPage.css'
import { details } from '../Projects/Details';
import Card from '../MasterProjectCard/Card';

const containerVariants = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: { staggerChildren: 0.05, delayChildren: 0.1 }
    }
};

const filterTabs = [
    { key: 'all', label: 'All' },
    { key: 'restobar', label: 'Restaurants' },
    { key: 'residential', label: 'Residential' },
    { key: 'commercial', label: 'Office Spaces' },
    { key: 'hospitality', label: 'Hospitality' },
    { key: 'food_court', label: 'Food Court' },
]

const typeCounts = {
    all: details.length,
    restobar: details.filter(d => d.type === 'restobar').length,
    residential: details.filter(d => d.type === 'residential').length,
    commercial: details.filter(d => d.type === 'commercial').length,
    hospitality: details.filter(d => d.type === 'hospitality').length,
    food_court: details.filter(d => d.type === 'food_court').length,
}

const ProjectPage = () => {
    const location = useLocation();
    const initialFilter = location.state?.initialFilter ?? 'all';
    const [filter, setFilter] = useState(initialFilter);
    const [items, setItems] = useState(details);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, []);

    useEffect(() => {
        if (filter === 'all') {
            setItems(details);
        } else {
            setItems(details.filter((item) => item.type === filter));
        }
    }, [filter])

    return (
        <div id='projects-page' className='master-project-page'>

            {/* Page header */}
            <div className='projects-page-header'>
              <div className='projects-page-header-inner'>
                <motion.div
                    className='back-nav'
                    initial={{ opacity: 0, x: -16 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <Link to="/" className='back-button'>← Back</Link>
                </motion.div>

                <motion.div
                    className='page-title-block'
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                >
                    <h1 className='master-page-title'>Our Work</h1>
                    <p className='master-page-subtitle'>
                        {items.length} {items.length === 1 ? 'project' : 'projects'} across residential, commercial, hospitality, and restaurant design.
                    </p>
                </motion.div>
              </div>
            </div>

            {/* Filter pills */}
            <div className='project-filters'>
                <div className='filter-list'>
                    {filterTabs.map((tab) => (
                        <motion.button
                            key={tab.key}
                            className='filter-pill'
                            onClick={() => setFilter(tab.key)}
                            animate={{
                                backgroundColor: filter === tab.key ? '#1A1A1A' : '#F5F5F5',
                                color: filter === tab.key ? '#ffffff' : '#1A1A1A',
                                borderColor: filter === tab.key ? '#1A1A1A' : '#E0E0E0',
                            }}
                            transition={{ duration: 0.2 }}
                        >
                            {tab.label}
                            <span className='pill-count'>{typeCounts[tab.key]}</span>
                        </motion.button>
                    ))}
                </div>
            </div>

            {/* Grid */}
            <AnimatePresence mode="wait">
                <motion.div
                    className='masterProject-page-cards-container'
                    variants={containerVariants}
                    initial="hidden"
                    animate="show"
                    key={filter}
                    layout
                >
                    {items.map((item, index) => (
                        <Card details={item} index={index} key={item.id || index} filter={filter} />
                    ))}
                </motion.div>
            </AnimatePresence>
        </div>
    )
}

export default ProjectPage
